import { render, staticRenderFns } from "./userViewHelpDesk.vue?vue&type=template&id=1dd02176"
import script from "./userViewHelpDesk.vue?vue&type=script&lang=js"
export * from "./userViewHelpDesk.vue?vue&type=script&lang=js"
import style0 from "./userViewHelpDesk.vue?vue&type=style&index=0&id=1dd02176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports